var validate = require("validate.js");
var uuidValidate = require('uuid-validate');


export default class Beacon {

	constructor(params) {
      	this.name = params.name;
        this.major = params.major;
        this.minor = params.minor;
        this.uuid = params.uuid;
        
        //this.uuid = "95ecc380-afe9-11e4-9b6c-751b66dd541e";
  	}


  	toString() {
        return this.name;
    }

    getName(){
    	  return this.name;
    }

    validateUUID(){
        return uuidValidate(this.uuid); 
    }

    isEqual(beacon){
        if(this.name.toLowerCase() == beacon.name.toLowerCase() || (this.major == beacon.major && this.minor == beacon.minor)){
          return true;
        }
        return false;
    }

    editIsEqual(beacon){
      if(this.name.toLowerCase() == beacon.name.toLowerCase() && (this.major == beacon.major && this.minor == beacon.minor)){
          return true;
        }
        return false;
    }
    
    validate(){
        var constraints = {
          major: {
            numericality: {
              onlyInteger: true,
              greaterThan: 0
            }
          },
          minor: {
            numericality: {
              onlyInteger: true,
              greaterThan: 0
            }
          },
          uuid: {
            presence: {
              allowEmpty: false
            },
          },
          name: {
            presence: true,
            length: {
              minimum: 2,
              message: "must be at least 2 characters"
            }
          }
        };

        return validate({
            major: this.major,
            minor: this.minor,
            uuid: this.uuid,
            name:this.name
          }, 
          constraints
        );
    }
}